import React, { useState, useCallback } from 'react';
import _ from 'underscore';
import PropTypes from 'prop-types';

/**
 * add a shim to scope context
 * as this wizard would be used in different work flows, it many have different Scopecontext
 */
export const ScopeContext = React.createContext([{}, _.noop]);

export const ScopeContextProvider = (props) => {
  const { serverContext, wizardContext } = props;
  const getScopeContext = useCallback(() => ({
    cid: _.result(serverContext.CurrentCustomer, 'Id', null),
    aid: _.result(serverContext.CurrentAccount, 'Id', null),
    uid: _.result(serverContext.CurrentUser, 'Id', null),
    campaignId: wizardContext.campaignId,
    adgroupId: wizardContext.adgroupId,
  }), [serverContext, wizardContext]);
  const [scopeContext, setScopeContext] = useState(getScopeContext);

  const updateScopeContext = useCallback(newContext => setScopeContext(prevState => ({
    ...prevState,
    ...newContext,
  })), []);

  return (
    <ScopeContext.Provider value={[scopeContext, updateScopeContext]}>
      {props.children}
    </ScopeContext.Provider >
  );
};

ScopeContextProvider.propTypes = {
  serverContext: PropTypes.shape({}).isRequired,
  wizardContext: PropTypes.shape({}).isRequired,
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]).isRequired,
};
